import { commonFunctions } from "../_utilities/commonFunctions";
import { configs } from "../config";
import { configes } from "../webData";

export const blogDetailService = {
  getBlogDetail,
  getBlogBySlug,
};


function getBlogDetail() {
  const requestOptions = commonFunctions.getRequestOptions("GET");
  return fetch(
    `${configs.localApiUrl}/getBlog/${configes.domainId}`,
    requestOptions
  ).then((response) => response.json());
}


function getBlogBySlug(data) {
  const extraHeaders = {
    "Content-Type": "application/json",
  };

  const requestOptions = commonFunctions.getRequestOptions(
    "POST",
    extraHeaders,
     JSON.stringify(data)
  );

  return fetch(
    `${configs.localApiUrl}/getBlogBySlug/${configes.domainId}`,
    requestOptions
  ).then((response) => response.json());
}
